import { api } from '@/shared/api/axios'
import type { ApiResponse } from '@/shared/types/auth.types'
import type {
  LoginRequest,
  LoginResponse,
  WebAuthnBeginResponse,
  WebAuthnCredentialFinishPayload,
  WebAuthnLoginBeginRequest,
} from '@/shared/types/auth.types'

export interface ForgotPasswordRequest {
  email: string
}

export interface ForgotPasswordResponse {
  message: string
}

export interface ResetPasswordWithTokenRequest {
  token: string
  newPassword: string
}

export const authService = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const res = await api.post<ApiResponse<LoginResponse>>('/auth/login', data)
    return res.data.data
  },

  /** Revoca el refresh token en el backend al cerrar sesión (best-effort). */
  logout: async (refreshToken: string): Promise<void> => {
    await api.post<ApiResponse<null>>('/auth/logout', { refreshToken })
  },

  forgotPassword: async (data: ForgotPasswordRequest): Promise<ForgotPasswordResponse> => {
    const res = await api.post<ApiResponse<ForgotPasswordResponse>>('/auth/forgot-password', data)
    return res.data.data
  },

  resetPassword: async (data: ResetPasswordWithTokenRequest): Promise<void> => {
    await api.post<ApiResponse<null>>('/auth/reset-password', data)
  },

  webauthnRegisterBegin: async (): Promise<WebAuthnBeginResponse> => {
    const res = await api.post<ApiResponse<WebAuthnBeginResponse>>('/auth/webauthn/register/begin')
    return res.data.data
  },

  webauthnRegisterFinish: async (payload: WebAuthnCredentialFinishPayload): Promise<void> => {
    await api.post<ApiResponse<null>>('/auth/webauthn/register/finish', payload)
  },

  webauthnLoginBegin: async (data: WebAuthnLoginBeginRequest): Promise<WebAuthnBeginResponse> => {
    const res = await api.post<ApiResponse<WebAuthnBeginResponse>>('/auth/webauthn/login/begin', data)
    return res.data.data
  },

  webauthnLoginFinish: async (payload: WebAuthnCredentialFinishPayload): Promise<LoginResponse> => {
    const res = await api.post<ApiResponse<LoginResponse>>('/auth/webauthn/login/finish', payload)
    return res.data.data
  },
}
